class Attributes {
  constructor(atribId, name, description, type, values, ws) {
    this.atribId = atribId;
    this.name = name;
    this.description = description;
    this.type = this.getType(type);
    this.values = values;
    this.ws = ws;
    this.nameAndType = name + " (" + this.type + ")";
  }

  getType(type) {
    switch (type) {
      case "I":
        return "Entero";
      case "S":
        return "Cadena";
      case "L":
        return "Lista";
      default:
        return type;
    }
  }

  static fromJson({ atribId, nombre, descripcion, tipo, valores, ws }) {
    return new Attributes(atribId, nombre, descripcion, tipo, valores, ws);
  }
}

export default Attributes;
